import { EMPTY_LIST } from '../../../constants/common'
import { EXCLUDE_FILTERS } from '../../Filter'

export function getEntityTabInhabitantsExcludeFilters(scopeFilterKey) {
  return [
    ...EXCLUDE_FILTERS,
    ...(scopeFilterKey ? [scopeFilterKey] : EMPTY_LIST),
  ]
}
